import { FacebookObject } from "./FacebookObject";
import { ValidationResponse } from "./ValidationResponse";

export class AdAccount extends FacebookObject {
    Validate(): ValidationResponse {
        let validationResponse = new ValidationResponse();
        validationResponse.IsValid = true;
        return validationResponse;
    }
}